import { useContext } from 'react';
import { ExperimentProviderContext } from '|/helpers/experiment';

function useExperimentBucket(experiment: string, possibleBuckets: string[]) {
  const { experiments, GetAssignedBucket } = useContext(ExperimentProviderContext);

  if (experiment in experiments) {
    return experiments[experiment].assignedBucket;
  }

  GetAssignedBucket({ experimentName: experiment, possibleBuckets });
  return null;
}

export default useExperimentBucket;
